import { useContentBriefBlockActions } from './use-content-brief-block-actions.hook'
import { useContentBriefBlockKeyboard } from './use-content-brief-block-keyboard.hook'

export interface UseContentBriefBlockHandlersProps {
  comment?: string
  draftComment: string
  isEditing: boolean
  setIsEditing: (value: boolean) => void
  setDraftComment: (value: string) => void
  onCommentChange: (comment: string | undefined) => void
}

export interface UseContentBriefBlockHandlersReturn {
  handleBlockClick: () => void
  handleSave: () => void
  handleCancel: () => void
  handleDelete: () => void
  handleKeyDown: (e: React.KeyboardEvent) => void
  handleBlockKeyDown: (e: React.KeyboardEvent) => void
}

export const useContentBriefBlockHandlers = ({
  comment,
  draftComment,
  isEditing,
  setIsEditing,
  setDraftComment,
  onCommentChange,
}: UseContentBriefBlockHandlersProps): UseContentBriefBlockHandlersReturn => {
  const actions = useContentBriefBlockActions({
    comment,
    draftComment,
    isEditing,
    setIsEditing,
    setDraftComment,
    onCommentChange,
  })

  const keyboard = useContentBriefBlockKeyboard({
    isEditing,
    handleBlockClick: actions.handleBlockClick,
    handleSave: actions.handleSave,
    handleCancel: actions.handleCancel,
  })

  return { ...actions, ...keyboard }
}
